export default __webpack_public_path__ + "static/media/activation.2d454e0f.png";